import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './tsx/App';
import reportWebVitals from './ts/reportWebVitals';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'


const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <App/>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
